import SkIcon from './SkIcon'

export default SkIcon



// WEBPACK FOOTER //
// ./src/components/Common/SkIcon/index.js